import React from 'react'
import { withRouter } from 'react-router-dom'
export default function withApplicationId (Component) {
    const ComponentWithApplicationId = props => {
      return (
        <Component
          {...props}
          applicationId={props.match.params.application}
        />
      )
    }  
    return withRouter(ComponentWithApplicationId);
  }


// WEBPACK FOOTER //
// ./src/HOCs/withApplicationId.js